/**
 * Flickity Slideshow Initialization
 * Simple script to initialize Flickity on slideshow components
 */

(function() {
  'use strict';

  // Wait for Flickity library to load
  function waitForFlickity(callback) {
    if (typeof Flickity !== 'undefined') {
      callback();
    } else {
      setTimeout(() => waitForFlickity(callback), 50);
    }
  }

  // Initialize Flickity on a slider element
  function initFlickitySlider(sliderElement) {
    // Check if already initialized
    if (sliderElement.classList.contains('flickity-enabled')) {
      return;
    }

    // Parse options from data-options attribute
    let customOptions = {};
    const optionsAttr = sliderElement.getAttribute('data-options');
    if (optionsAttr) {
      try {
        customOptions = JSON.parse(optionsAttr);
      } catch (e) {
        console.error('Failed to parse Flickity options:', e, optionsAttr);
      }
    }

    // Get dots style
    const dotsStyle = sliderElement.getAttribute('data-dots') || 'dark';
    sliderElement.setAttribute('data-dots-style', dotsStyle);

    // Default options matching melted-matcha-theme
    const defaultOptions = {
      cellSelector: '[data-slide]',
      contain: true,
      wrapAround: true,
      adaptiveHeight: false,
      pageDots: true,
      prevNextButtons: false, // Hide arrows, use dots only
      fade: false,
      autoPlay: false,
      draggable: true,
      friction: 0.8,
      selectedAttraction: 0.14,
      on: {
        ready: function() {
          sliderElement.classList.add('flickity-initialized');
          // Trigger animations on first slide
          const firstSlide = sliderElement.querySelector('[data-slide]');
          if (firstSlide) {
            firstSlide.classList.add('is-selected');
            triggerSlideAnimations(firstSlide);
          }
        },
        change: function(index) {
          // Get all slides
          const slides = sliderElement.querySelectorAll('[data-slide]');

          // Remove is-selected from all
          slides.forEach(slide => slide.classList.remove('is-selected'));

          // Add to current slide
          const currentSlide = slides[index];
          if (currentSlide) {
            currentSlide.classList.add('is-selected');
            triggerSlideAnimations(currentSlide);
          }
        }
      }
    };

    // Merge options
    const options = Object.assign({}, defaultOptions, customOptions);

    // Initialize Flickity
    try {
      const flkty = new Flickity(sliderElement, options);

      // Store reference on element
      sliderElement.flickityInstance = flkty;

      // Handle autoplay pause/unpause on hover
      if (options.autoPlay) {
        sliderElement.addEventListener('mouseenter', () => {
          flkty.pausePlayer();
        });

        sliderElement.addEventListener('mouseleave', () => {
          flkty.unpausePlayer();
        });
      }

      console.log('Flickity initialized on slideshow:', sliderElement.id);
    } catch (e) {
      console.error('Failed to initialize Flickity:', e);
    }
  }

  // Trigger animations on slide
  function triggerSlideAnimations(slide) {
    const elementsToAnimate = slide.querySelectorAll('[data-aos]');
    if (elementsToAnimate.length) {
      elementsToAnimate.forEach((el) => {
        el.classList.remove('aos-animate');
        requestAnimationFrame(() => {
          setTimeout(() => {
            el.classList.add('aos-animate');
          }, 0);
        });
      });
    }
  }

  // Initialize all sliders on page
  function initAllSliders() {
    const sliders = document.querySelectorAll('slider-component[data-use-flickity]');

    if (sliders.length === 0) {
      return;
    }

    waitForFlickity(() => {
      sliders.forEach(initFlickitySlider);
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Also listen for Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const sliders = event.target.querySelectorAll('slider-component[data-use-flickity]');
    waitForFlickity(() => {
      sliders.forEach(initFlickitySlider);
    });
  });

})();
